"use client";
import { useState, useEffect } from "react";
import axiosInstance from "@/utils/axiosInstance";
import Slider from "react-slick";
import CoachsCard from "@/components/ui/coachs/CoachsCard";
import { CoachsType } from "@/utils/valuesFields";

interface Coach {
  id: number;
  name: string;
  img_url: string;
  coach_type_id: number;
  username: string;
}

export default function CoachsCarousel() {
  const [coachs, setCoachs] = useState<Coach[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.NEXT_PUBLIC_API_URL_BASE}/coachs`)
      .then((response) => {
        //console.log(response.data);
        setCoachs(response.data);
        setLoading(false);
      })
      .catch((error) => {
        //console.error(error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="container mx-auto py-16 ">
      <div className="text-center">
        <span className="font-light text-3xl">COACHS Y NUTRICIONISTAS</span>
        <h2 className="font-bold text-4xl mt-5">
          UN EQUIPO DE ESPECIALISTAS CREADO PARA TI
        </h2>
      </div>
      <div className="mt-10">
        {loading ? (
         <div className="py-10 text-center text-gray-500">Cargando...</div>
        ) : coachs.length === 0 ? (
          <div className="w-full col-span-2 md:col-span-4 flex items-center justify-center h-32 rounded-lg border border-neutral-300 bg-neutral-50 text-neutral-600">
              No se encontraron coachs.
            </div>
        ) : (
          <Slider
            dots={true}
            arrows={false}
            infinite={true}
            speed={500}
            slidesToShow={5}
            slidesToScroll={5}
            responsive={[
              {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                },
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ]}
          >
            {coachs.map((coach) => (
              <CoachsCard
                key={coach.id}
                username={coach.id === 1 ? coach.username : ""}
                img_url={
                  coach.img_url
                    ? coach.img_url
                    : "https://maluapp.b-cdn.net/resources/Women.png"
                }
                type={
                  CoachsType.find((item) => item.id === coach.coach_type_id)?.title
                }
                name={coach.name}
              />
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
}
